import React from 'react';
import PropTypes from 'prop-types';
import { Select, Tag } from 'antd';
import Flex from '../../../shared/components/basic/Flex';
import { Text } from '../../../shared/components';

export default function TratamientosCheckBoxs({
  tratamientos, tratamientoSeleccionado, handleChangeTratamientos, modoNoPel, disabled, loading,
}) {
  if (modoNoPel && tratamientoSeleccionado) {
    return (
      <Select size="small" value={tratamientoSeleccionado.id} onChange={id => handleChangeTratamientos(id)} style={{ width: 270 }} loading={loading}>
        {tratamientos.map(({ id, nombre, precioTratamiento }) => (
          <Select.Option key={id} value={id}>
            {id !== 0 && (precioTratamiento ? `${nombre} (+${precioTratamiento}€)` : `${nombre} (sin coste)`)}
            {id === 0 && (precioTratamiento ? `${nombre} (+${precioTratamiento}€)` : `${nombre}`)}
          </Select.Option>
        ))}
      </Select>
    );
  }
  return (
    <Flex>
      {tratamientos.map(({ id, nombre, isSelected }) => {
        const selected = isSelected;
        let classesForTag = 'tratamiento ';
        if (!selected && !disabled) {
          classesForTag += 'tratamiento-tag';
        } else if (selected && !disabled) {
          classesForTag += 'tratamiento-tag-checked';
        } else if (!selected && disabled) {
          classesForTag += 'tratamiento-tag-disabled';
        } else if (selected && disabled) {
          classesForTag += 'tratamiento-tag-disabled-checked';
        }
        return (
          <Tag.CheckableTag
            type="tratamiento"
            className={classesForTag}
            key={id}
            checked={selected}
            onChange={() => handleChangeTratamientos(id)}
            style={{
              textAlign: 'center', marginRight: 22,
            }}
          >
            <Text fontSize={14}>{nombre.toUpperCase()}</Text>
          </Tag.CheckableTag>
        );
      })}
    </Flex>
  );
}

TratamientosCheckBoxs.propTypes = {
  tratamientos: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  handleChangeTratamientos: PropTypes.func,
  tratamientoSeleccionado: PropTypes.shape({
    key: PropTypes.number,
    nombre: PropTypes.string,
    descripcion: PropTypes.string,
    activo: PropTypes.bool,
    tratamientoDefectoId: PropTypes.number,
    id: PropTypes.number,
    valor: PropTypes.number,
  }),
  disabled: PropTypes.bool,
  modoNoPel: PropTypes.bool,
  loading: PropTypes.bool,
};

TratamientosCheckBoxs.defaultProps = {
  handleChangeTratamientos: () => {},
  tratamientoSeleccionado: null,
  disabled: false,
  modoNoPel: false,
  loading: false,
};
